import { Link, useParams } from "react-router";
import type { SectionSlot } from "./sections";

// Placeholder body for a DEFINE/RUN slot while Epic 0 is in flight. It names
// what will live here and links to the artefact's current home, so the new
// surfaces are inspectable before the editors move (#2216/#2217/#2218).
export function MigrationStub({ slot }: { slot: SectionSlot }) {
  const { id } = useParams();

  return (
    <section
      data-testid="migration-stub"
      data-slot={slot.to}
      className="rounded-lg bg-card p-4 shadow-sm ring-1 ring-ring"
    >
      <h2 className="text-sm font-medium text-text-primary">{slot.label}</h2>
      <p className="mt-1 text-sm text-text-muted">{slot.blurb}</p>
      {slot.currentPath ? (
        <Link
          to={`/campaigns/${id}/${slot.currentPath}`}
          className="mt-3 inline-block text-sm font-medium text-accent hover:underline"
        >
          Currently lives here →
        </Link>
      ) : (
        <p className="mt-3 text-xs text-text-faint">Coming here as the campaign reorg lands.</p>
      )}
    </section>
  );
}
